import api from "./api";
import notFoundCover from '../assets/noImage.svg';

export default class BookService {
    static async handleBookStatus(bookInformation, newStatus) {
        const isInReadings = await this.findBookInReading(bookInformation);

        if (isInReadings) {
            return await this.updateReadings(bookInformation, newStatus);
        }

        // //verifica se o livro que veio da api do google já está cadatrado na nossa table de livros
        let bookId = await this.getBookIdFromBooks(bookInformation);

        if(!bookId){
            //post na tabela de livros
            bookId = await this.createNewBook(bookInformation);
        }

        // //post na tabela de readings
        return await this.createNewReading(bookId, newStatus);
    }

    //PRIMEIRO - Verificar se o livro existe na table Readings
    static async findBookInReading(bookInformation) {
        if (!bookInformation?.book?.id) {
            return false;
        }

        try {
            let found;
            const { data } = await api.get('/readings', {
                headers: {
                    'x-session-token': JSON.parse(localStorage.getItem('token')),
                }
            });
            Object.keys(data).forEach((key) => {
                if (found) {
                    return;
                }
                found = data[key].find(item => item.book.id === bookInformation.book.id);
            });

            return !!found;
        } catch(error) {
            console.error(error);
        }
    }

    //SEGUNDO - OPÇÃO A - Se ele achar vamos fazer um update em readings
    static async updateReadings(bookInformation, currentStatus) {
        try {
            const { data } = await api.put(`/readings/${bookInformation.book.id}`, { currentStatus }, {
                headers: {
                    'x-session-token': JSON.parse(localStorage.getItem('token')),
                }
            });
            return data;
        } catch(error) {
            console.error(error);
        }
    }

    //POST Tabela e livros
    static async createNewBook(bookInformation) {

        try {
            const { data } = await api.post('/books', { 
                googleId: bookInformation.id || null,
                title: this.getValueWithFallback(bookInformation?.volumeInfo?.title),
                pages: bookInformation?.volumeInfo?.pageCount || 0,
                publisher: this.getValueWithFallback(bookInformation?.volumeInfo?.publisher),
                imageUrl: bookInformation?.volumeInfo?.imageLinks?.smallThumbnail || notFoundCover,
                author: this.getValueWithFallback(bookInformation?.volumeInfo?.authors?.[0]),
                description: this.getValueWithFallback(bookInformation?.volumeInfo?.description)
             }, {
                headers: {
                    'x-session-token': JSON.parse(localStorage.getItem('token')),
                }
            });
            return data[0].liv_id;
        } catch(error) {
            console.error(error);
        }
    }
    
    //POST Readings
    static async createNewReading(id, status) {
        try {
            const { data } = await api.post('/readings', { 
                bookId: id,
                status,
                initialPage: 0,
                currentPage: 0,
                readingTime: "00:00:00"
            }, {
                headers: {
                    'x-session-token': JSON.parse(localStorage.getItem('token')),
                }
            });
            return data[0];
        } catch(error) {
            console.error(error);
        }
    }

    //GET BOOKS - Filtrado pelo id do google
    static async getBookIdFromBooks(bookInformation) {
        try {
            const { data } = await api.get(`/books/googleId/${bookInformation.id}`, {
                headers: {
                    'x-session-token': JSON.parse(localStorage.getItem('token')),
                }
            });

            return data.googleId === bookInformation.id ? data.id : false;
        } catch(error) {
            console.error(error);
        }
    }

    static getValueWithFallback(value) {
        return value || 'Não encontrado';
    }
}
